import { useMemo } from 'react'

import { atom, useAtom } from 'jotai'

const slugAtom = atom('')

export default function useGameDialog() {
  const [slug, setGameSlug] = useAtom(slugAtom)
  const open = useMemo(() => (newSlug: string) => setGameSlug(newSlug), [setGameSlug])
  const close = useMemo(() => () => setGameSlug(''), [setGameSlug])

  return { slug, open, close }
}
